export default {
  toastr: {
    create_error: 'An error occurred while creating {{model}}. Fix the errors and try again',
    create_error_default: 'An error occurred while creating {{model}}.',
    create_successful: '{{model}} was created successfully',
    delete_error: 'An error occurred while deleting {{model}}',
    delete_successful: '{{model}} successfully deleted',
    cancel_successful: '{{model}} successfully canceled',
    unauthorized_successful: '{{model}} successfully unauthorized',
    auth_successful: '{{model}} successfully authorized',
    link_successful: '{{model}} successfully linked',
    update_onu_successful: '{{model}} was updated successfully',
    change_password_successful: 'Password was updated successfully',
    change_ssid_successful: 'SSID was updated successfully',
    errors: {
      invalid: 'Something went wrong, please contact support'
    },
    form_has_errors: 'There are errors in the form. Fix the errors and try again',
    news_notification: {
      publish: 'The news was sent to be published correctly'
    },
    sent_successfully: '{{model}} was sent successfully',
    service_invoice: {
      generate_service_invoice: {
        success: {
          header: 'Periodic invoice',
          body: 'The periodic invoice was successfully generated'
        }
      },
      cancel_initial_invoice: {
        success: {
          header: 'Initial invoice',
          body: 'The initial invoice generation message will not be displayed again'
        }
      }
    },
    subscription: {
      create_subscription: 'Successful subscription',
      subscription_cancelled: 'Subscription cancelled'
    },
    uniq_code_numeric: {
      assign_successful: 'CUN assigned successfully',
      create_successful: 'The CUN format was created successfully',
      delete_successful: 'The CUN format was successfully deleted',
      update_successful: 'The CUN format was updated successfully'
    },
    update_error: 'An error occurred while updating {{model}}. Fix the errors and try again',
    update_successful: '{{model}} was updated successfully',
    verifying_model: 'Verifying {{model}}'
  }
};
